module.exports = __webpack_public_path__ + "asset/pharos--2cd706.svg";